import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Observer from 'react-intersection-observer'
import { companiesByYearAndTopicSelector } from '../redux/selector'
import CompanyProfile from './CompanyProfile/CompanyProfile'

const Container = styled.div`
  display: flex;
  overflow: scroll;
  padding: 4rem;
`

const Profile = styled(CompanyProfile)`
  align-self: flex-start;
  margin-right: 4rem;
`

const Placeholder = styled.div`
  width: 550px;
`

const List = ({ companies }) => {
  return (
    <Container>
      {companies.map(c => (
        <Observer key={`profile-${c.id}`}>
          {({ inView, ref }) => (
            <div ref={ref} style={{ paddingTop: '4rem' }}>
              {inView ? (
                <Profile company={c} />
              ) : (
                <Placeholder>Loading ...</Placeholder>
              )}
            </div>
          )}
        </Observer>
      ))}
    </Container>
  )
}

const mapStateToProps = state => ({
  companies: companiesByYearAndTopicSelector(state),
})

export default connect(mapStateToProps)(List)
